import React from 'react';
import { Page } from 'src/components';
import { Container, Typography } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import LiabilityScheduleCalendar from './components/LiabilityScheduleCalendar';
// import { Toolbar } from './components';
// import { LiabilityChartListing } from './components/LiabilityChartListing';

const LiabilityScheduleView = () => {
  return (
    <Page title="Liability Schedule" className={''}>
      <Container maxWidth={false} style={{ marginTop: '1.5rem' }}>
        <Alert severity='error' style={{ marginBottom: '1rem' }}>
          <AlertTitle>WARNING</AlertTitle>
          PLEASE NOTE THAT THE LIABILITY SCHEDULE IS CURRENTLY IN DEVELOPMENT AND
          THIS IS JUST A MOCKUP. IT IS NOT YET FUNCTIONAL AND IS SUBJECT TO
					CHANGE. THE DATA SHOWN IS FOR DEMONSTRATION PURPOSES ONLY AND DOES NOT
          REPRESENT ACTUAL LIABILITIES.
        </Alert>
        <Typography color="textPrimary" gutterBottom variant="h3">
          Liability Schedule
        </Typography>
        <Typography color="textPrimary" gutterBottom variant="h4">
          Monthly Total: ₱999,999,999.99
        </Typography>
        <LiabilityScheduleCalendar />
      </Container>
    </Page>
  );
};

export default LiabilityScheduleView;
